export const getAddonOptionLabel = (option, language = "en") => {
  const localizedLabel =
    option?.displayName?.[language] ||
    option?.displayName?.en ||
    option?.displayName?.zh ||
    option?.key ||
    "Add-on";

  return option?.unit > 1 ? `${localizedLabel} × ${option.unit}` : localizedLabel;
};

export const getReceiptDisplayTotal = (data = {}) => {
  return (data.total || 0) + (data.txAdjustmentTotal || 0) + (data.discountAmount || 0);
};

export const buildReceiptPaymentRows = (
  data = {},
  { language = "en", t = (key) => key } = {},
) => {
  const addonRows = (data.addonOptions || []).map((option, index) => ({
    key: `addon-${option?.key || index}-${index}`,
    label: getAddonOptionLabel(option, language),
    value: option?.baseTotalPrice || 0,
    visible: true,
    isAddon: true,
  }));

  return [
    {
      key: "fare",
      label: t("fare"),
      value: data.fare || 0,
      visible: true,
    },
    {
      key: "extras",
      label: t("extras"),
      value: data.extra || 0,
      visible: !!data.extra,
    },
    {
      key: "additionalBookingFee",
      label: t("additionalBookingFee"),
      value: data.additionalBookingFee || 0,
      visible: !!data.additionalBookingFee,
    },
    ...addonRows,
    {
      key: "orderBoostFee",
      label: t("orderBoostFee"),
      value: data.boostAmount || 0,
      visible: !!data.boostAmount,
    },
    {
      key: "tips",
      label: t("tips"),
      value: data.dashTips || 0,
      visible: !!data.dashTips,
    },
    {
      key: "platformFee",
      label: t("platformFee"),
      value: data.dashFee || 0,
      visible: true,
    },
    {
      key: "discount",
      label: t("discount"),
      value: data.discountAmount || 0,
      visible: !!data.discountAmount,
    },
    {
      key: "adjustment",
      label: t("adjustment"),
      value: data.txAdjustmentTotal || 0,
      visible: !!data.txAdjustmentTotal,
    },
    {
      key: "total",
      label: t("total"),
      value: getReceiptDisplayTotal(data),
      visible: true,
      isTotal: true,
    },
  ].filter((row) => row.visible);
};
